import { FaPlus } from "react-icons/fa6";
import { TbReorder } from "react-icons/tb";

import Modal from "@/components/Modal";
import Button from "@/components/Button";
import CreateLectureItem from "./CreateLectureItem";
import CreateMaterial from "./CreateMaterial";
import usePermission from "../../../../hooks/usePermission";
import ReorderLectureItems from "./ReorderLectureItems";

function HeaderOperations({ lectureItems }) {
    const { can } = usePermission();

    return (
        <div className="flex flex-wrap items-center justify-center gap-3 py-5">
            {can("create:course:lecture:items") && (
                <Modal>
                    <Modal.Open opens={`createVideoORQuiz`}>
                        <Button type="primary" className={"w-fit h-10"}>
                            <span className="flex items-center justify-center gap-2">
                                <FaPlus className="text-xl" />
                                فيديو او اختبار
                            </span>
                        </Button>
                    </Modal.Open>
                    <Modal.Window name={`createVideoORQuiz`}>
                        <CreateLectureItem />
                    </Modal.Window>
                </Modal>
            )}
            {can("create:course:lecture:materials") && (
                <>
                    <Modal>
                        <Modal.Open opens={`createMaterial`}>
                            <Button type="primary" className={"w-fit h-10"}>
                                <span className="flex items-center justify-center gap-2">
                                    <FaPlus className="text-xl" />
                                    ماتريال
                                </span>
                            </Button>
                        </Modal.Open>
                        <Modal.Window name={`createMaterial`}>
                            <CreateMaterial />
                        </Modal.Window>
                    </Modal>
                </>
            )}
            {can("reorder:course:lecture:items") && (
                <Modal>
                    <Modal.Open opens={`reorderLectureItems`}>
                        <Button type="primary" className={"w-fit h-10"}>
                            <span className="flex items-center justify-center gap-2">
                                <TbReorder className="text-xl" />
                                تغيير الترتيب
                            </span>
                        </Button>
                    </Modal.Open>
                    <Modal.Window
                        name={`reorderLectureItems`}
                        enableOutsideClick={false}
                    >
                        <ReorderLectureItems lectureItems={lectureItems.data} />
                    </Modal.Window>
                </Modal>
            )}
        </div>
    );
}

export default HeaderOperations;
